import React from "react";
import banner from "../assets/about.jpg";
import aboutService from "../assets/about-service.jpg";
import abouTrainings from "../assets/about-trainings.jpg";
import { NavLink } from "react-router-dom";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
export default function About() {
  return(
    
    <div>
       <div
        style={{
          width: "100%",
          height: "300px",         
          backgroundImage: `url(${banner})`,
          backgroundSize: "cover",  
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff"
        }}
      >

      </div>

     <div className="p-5 flex justify-content-center">
      <Card className="company-card w-full md:w-8">
        
        <h2 className="text-center company-title mb-3">
          PESIL Infosol Pvt Ltd
        </h2>

        <div className="flex justify-content-center my-3">
  <Divider className="company-divider" />
</div>

        <div className="mt-3">
    <div className="flex align-items-center justify-content-center mb-2 gap-2">
      <i className="pi pi-check-circle text-green-500"></i>
      <span>Systems Engineering process using IBM Tools & OSLC.</span>
    </div>

    <div className="flex align-items-center justify-content-center mb-2 gap-2">
      <i className="pi pi-check-circle text-green-500"></i>
      <span>SysML models using Rhapsody.</span>
    </div>

    <div className="flex align-items-center justify-content-center mb-2 gap-2">
      <i className="pi pi-check-circle text-green-500"></i>
      <span>Product LifeCycle Management process & tools.</span>
    </div>
  </div>


        <p className="company-highlight text-center mt-4">
        PESIL follows Global Delivery model to deliver IT services.
        </p>
      </Card>
    </div>
    <div className="services-wrapper">

      <div className="grid">

        {/* LEFT CARD */}
        <div className="col-12 md:col-6">
          <Card className="service-card">
            <img
                 src={aboutService}
              alt="Services"
              className="service-image"
            />

            <p className="service-text">
              Explore our wide range of services, including software
              consulting, implementation, and lifecycle management.
            </p>
   <p className="company-highlight text-center mt-4">
Our Services
        </p>
            <NavLink to="/services" className="service-link">
              Learn more about our services »
            </NavLink>
          </Card>
        </div>

        {/* RIGHT CARD */}
        <div className="col-12 md:col-6">
          <Card className="service-card">
            <img
              src={abouTrainings}
              alt="Training"
              className="service-image"
            />

            <p className="service-text">
             We provide training for teams to enhance their understanding of IBM software products and solutions.
            </p>
   <p className="company-highlight text-center mt-4">
Training Programs
        </p>
            <NavLink to="/trainings" className="service-link">
             Discover our training programs »
            </NavLink>
          </Card>
        </div>

      </div>
    </div>

      </div>
  )
}
